(function ($) {

  $(document).ready(() => {

    $('.carousel-post').each(function () {
      tns({
        "container": this,
        "edgePadding": 18,
        "fixedWidth": 286,
        "swipeAngle": false,
        "speed": 400,
        "gutter": 18,
        "navPosition": "bottom",
        "responsive": {
          "1200": {
            "disable": true
          }
        }
      });
    });

    $('.carousel-post-desktop').each(function () {
      let slider_post = tns({
        "container": this,
        "swipeAngle": false,
        "speed": 400,
        "navPosition": "bottom",
        "mouseDrag": true,
        "disable": true,
        "nav": false,
        "responsive": {
          "1200": {
            "disable": false
          }
        }
      });

      $(this).closest('.block-carousel-articles').find('.prev').on('click', function () {
        slider_post.goTo('prev');
      });

      $(this).closest('.block-carousel-articles').find('.next').on('click', function () {
        slider_post.goTo('next');
      });

    });
    
  })
})(jQuery);
